import { Col, Row } from "antd";
import styled from "styled-components";
import theme from "../../../theme";

export const IndustryDescription = styled.div`
  max-width: 809px;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 57px;
  margin-top: 30px;
  ul{
    padding-left: 25px;
  }
  li a{
    color: ${theme.black};
  }
  li a:hover{
    color: ${theme.cyan};
    text-decoration: underline;
  }
  h3 {
    max-width: 659px;
    font-size: 40px;
    line-height: 52px;
    margin-bottom: 36px;

    @media (max-width: 768px) {
      font-size: 34px;
      line-height: 42px;
    }
    @media (max-width: 480px) {
      font-size: 30px;
      line-height: 42px;
    }
    @media (max-width: 380px) {
      font-size: 24px;
      line-height: 34px;
    }
  }

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 32px;
  }
`;

export const LogoContainer = styled(Row)`
  margin: 96px 0 0;
  display: flex;
  justify-content: space-between !important;
  align-items: center;

  @media (max-width: 767px) {
    justify-content: space-between !important;
    margin: 72px 0 24px;
  }
`;

export const Logo = styled(Col)`
  margin-bottom: 96px;
  text-align: center;
  img {
    margin-bottom: 0rem;
  }

  @media (max-width: 767px) {
    margin-bottom: 48px !important;
  }

  @media (max-width: 426px) {
    img {
      object-fit: contain !important;
      opacity: 1;
      max-height: 57px !important;
      max-width: 120px;
    }
  }
`;
